import { render, staticRenderFns } from "./InfoSpot.vue?vue&type=template&id=5a1d39b5&scoped=true"
import script from "./InfoSpot.vue?vue&type=script&lang=js"
export * from "./InfoSpot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1d39b5",
  null
  
)

export default component.exports